
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M11.907 1.5H6.574c-.55 0-1.078.246-1.467.683a2.5 2.5 0 0 0-.607 1.65c0 .62.219 1.213.607 1.65.39.438.917.684 1.467.684m0 0h3.852c.55 0 1.078.245 1.467.683A2.5 2.5 0 0 1 12.5 8.5c0 .619-.219 1.212-.607 1.65a1.96 1.96 0 0 1-1.467.683M6.574 6.167c-.55 0-1.078.245-1.467.683A2.5 2.5 0 0 0 4.5 8.5c0 .619.219 1.212.607 1.65.39.438.917.683 1.467.683h3.852m0 0c.55 0 1.078.246 1.467.684.388.437.607 1.03.607 1.65a2.5 2.5 0 0 1-.607 1.65 1.96 1.96 0 0 1-1.467.683H4.5"}})])
          )
        }
      }
    